import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { extraConfigProducts, getProductByLocation } from '../helpers/store';
import { isShippingRestrictedForParent } from '../helpers/internationalRestriction';
import ConfigScreen from './configScreen';
import PackageUnavailable from './PackageUnavailable';

const gridStyle = {};

// The "some items hidden" notice itself is rendered inside SlotSelector,
// under the bundle title where it's contextual to the slot grid the parent
// is filling — that keeps it out of the back-button area at the top.
export const Product = ({ shoot, parent, ...props }) => {
  const product = getProductByLocation(
    shoot?.shootProducts,
    props.location,
    extraConfigProducts(shoot),
  );
  const { child_products } = product;

  const restricted = isShippingRestrictedForParent(shoot?.shoot, parent);
  const visibleChildren =
    restricted && Array.isArray(child_products)
      ? child_products.filter((c) => c?.requires_shipping !== true)
      : child_products;

  // Nothing left to pick: an empty rail would let the customer walk into
  // addToCart's refusal with no way to satisfy it (ENG-1683).
  if (!visibleChildren || visibleChildren.length === 0) {
    return <PackageUnavailable />;
  }

  return (
    <ConfigScreen
      itemsDesktop={4}
      itemsMobile={2}
      gridStyle={gridStyle}
      items={visibleChildren}
      instruction="Select a Product"
    />
  );
};

const mapStateToProps = (state) => ({
  shoot: state.shoot,
  parent: state.parent,
});

export default withRouter(connect(mapStateToProps)(Product));
